export default {
        heading:'',
        content:'',
        email:'siripongsrisukha@gmail.com',
        campaignName:'shopchamp_Onesignal',
        big_picture:'',
        url:'',
        data:'',
    }

  

